const hogPrefix = 'hog_';

const getHogKey = (key:string) => {
    return `${hogPrefix}${key}`;
};

export const cacheToLocalStorage = (flag:string, flagValue:string) => {
    const hogKey = getHogKey(flag);
    const expiration = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem(hogKey, `${expiration}:${flagValue}`);
};

export const checkLocalStorage = (flag: string) => {
    const hogKey = getHogKey(flag);
    const cachedResult = localStorage.getItem(hogKey);
    if (cachedResult) {
        const [expiration, cached] = cachedResult.split(/:(.*)/);
        if (Date.now() < parseInt(expiration, 10)) {
            return cached;
        } else {
            localStorage.removeItem(hogKey);
        }
    }
};

// Removes hog events from local storage. The default removes expired flags but optionally can remove all posthog values
export const cleanUpLocalStorage = (clearAll?:boolean) => {
    Object.keys(localStorage).filter(k => k.startsWith(hogPrefix)).forEach((k) => {
        if (clearAll) {
            localStorage.removeItem(k);
        } else {
            const value = localStorage.getItem(k)!;
            const [expiration] = value.split(/:(.*)/);
            if (Date.now() > parseInt(expiration, 10)) {
                localStorage.removeItem(k);
            }
        }
    });
};
